import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import InputMask from 'react-input-mask';

function InputMasked(props) {
  const { label, mask, value, onChange,helperText, onBlur, disabled, ...other } = props;

  return (
    <InputMask mask={mask} value={value} onChange={onChange} onBlur={onBlur} disabled={disabled}>
      {() => <TextField label={label} {...other} helperText={helperText} error={helperText ? true : false} />}
    </InputMask>
  );
}

InputMasked.propTypes = {
  label: PropTypes.string.isRequired,
  mask: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
};

export default InputMasked;
